<script module lang="ts">
	import { anyGetter, type GenericScaleOptions } from '../../utils/accessors.js';
	import type { Snippet } from 'svelte';

	export interface SnippetContext<Datum> {
		datum: Datum;
		index: number;
	}

	export interface ColumnProps<Datum> {
		data: Datum[];
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		xScale: GenericScaleOptions<Datum, any, number>;
		children: Snippet<[SnippetContext<Datum>]>;
	}
</script>

<script lang="ts" generics="Datum">
	let { data, xScale, children }: ColumnProps<Datum> = $props();

	let xGet = $derived(anyGetter(xScale));
</script>

{#each data as datum, idx (datum)}
	{@const x = xGet(datum)}
	{@const snippetContext = { datum, index: idx }}
	<g transform="translate({x}, 0)">
		{#if children}
			{@render children(snippetContext)}
		{/if}
	</g>
{/each}
